/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentOrderViewGooglePayPaymentRequestMerchantInfoFromJSON, PaymentOrderViewGooglePayPaymentRequestMerchantInfoToJSON, } from './PaymentOrderViewGooglePayPaymentRequestMerchantInfo';
import { PaymentOrderViewGooglePayPaymentRequestTransactionInfoFromJSON, PaymentOrderViewGooglePayPaymentRequestTransactionInfoToJSON, } from './PaymentOrderViewGooglePayPaymentRequestTransactionInfo';
import { PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerFromJSON, PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerToJSON, } from './PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInner';
/**
 * Check if a given object implements the PaymentOrderViewGooglePayPaymentRequest interface.
 */
export function instanceOfPaymentOrderViewGooglePayPaymentRequest(value) {
    if (!('allowedPaymentMethods' in value) || value['allowedPaymentMethods'] === undefined)
        return false;
    if (!('apiVersion' in value) || value['apiVersion'] === undefined)
        return false;
    if (!('apiVersionMinor' in value) || value['apiVersionMinor'] === undefined)
        return false;
    if (!('merchantInfo' in value) || value['merchantInfo'] === undefined)
        return false;
    if (!('transactionInfo' in value) || value['transactionInfo'] === undefined)
        return false;
    return true;
}
export function PaymentOrderViewGooglePayPaymentRequestFromJSON(json) {
    return PaymentOrderViewGooglePayPaymentRequestFromJSONTyped(json, false);
}
export function PaymentOrderViewGooglePayPaymentRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'allowedPaymentMethods': (json['allowed_payment_methods'].map(PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerFromJSON)),
        'apiVersion': json['api_version'],
        'apiVersionMinor': json['api_version_minor'],
        'merchantInfo': PaymentOrderViewGooglePayPaymentRequestMerchantInfoFromJSON(json['merchant_info']),
        'transactionInfo': PaymentOrderViewGooglePayPaymentRequestTransactionInfoFromJSON(json['transaction_info']),
    };
}
export function PaymentOrderViewGooglePayPaymentRequestToJSON(json) {
    return PaymentOrderViewGooglePayPaymentRequestToJSONTyped(json, false);
}
export function PaymentOrderViewGooglePayPaymentRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'allowed_payment_methods': (value['allowedPaymentMethods'].map(PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerToJSON)),
        'api_version': value['apiVersion'],
        'api_version_minor': value['apiVersionMinor'],
        'merchant_info': PaymentOrderViewGooglePayPaymentRequestMerchantInfoToJSON(value['merchantInfo']),
        'transaction_info': PaymentOrderViewGooglePayPaymentRequestTransactionInfoToJSON(value['transactionInfo']),
    };
}
